import { Module } from "wrapper6";
import Glide from '@glidejs/glide';
import { debounce } from '../utils/_debounce';
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";
import anime from 'animejs';

var $ = jQuery;

export default class NewsCover extends Module {

	ready(app) {

        const SLIDER_CONTAINERS = document.querySelectorAll('.mtt-news-cover-slider');

        if (SLIDER_CONTAINERS.length) {
			for (let i = 0; i < SLIDER_CONTAINERS.length; i++) {
                new NewsCoverSlider(SLIDER_CONTAINERS[i]);
			}
        }
    }
}

class NewsCoverSlider {

    constructor(WRAPPER) {

        this.DURATION = 10000; // 10 seconds
        this.SLIDER_CONTAINER = WRAPPER;
        this.GLIDE = this.SLIDER_CONTAINER.querySelector('.glide');
        this.SLIDE_WRAPPER = this.SLIDER_CONTAINER.querySelector('.glide__slides');
        this.GLIDE_SLIDES = this.SLIDER_CONTAINER.querySelectorAll('.glide__slide');
        this.COUNT = this.SLIDER_CONTAINER.querySelectorAll('.glide__slide').length;
        this.ARROW_LEFT = this.SLIDER_CONTAINER.querySelector('.glide__arrows .glide__arrow--left');
        this.ARROW_RIGHT = this.SLIDER_CONTAINER.querySelector('.glide__arrows .glide__arrow--right');
        this.PROGRESS_BAR = this.SLIDER_CONTAINER.querySelector('.mtt-news-cover-slider__progress-bar');
        this.slide_interval;
        
        // Is glide present?
        if (this.GLIDE && this.GLIDE_SLIDES.length) {

            this.SLIDER = new Glide(this.GLIDE, {
                type: 'carousel',
                startAt: 0,
                perView: 1,
                gap: 0,
                animationDuration: 700,
                keyboard: false,
                autoplay: this.DURATION,
                hoverpause: false
            }).mount();

            // Is slider slidable?
            this.isSlidable();
            
            // Set container height
            this.setContainerHeight(false);

            // Update arrows when slider is run
            this.SLIDER.on('run', () => { 

                // Set disabled class for correct arrow
                this.arrowHandler();
                
                // Set height of container when slide is switched
                this.setContainerHeight();

                // Run animation
                this.progressBarAnimation();

            });
            
            // Set height of container when window is resized
            window.addEventListener('resize', debounce(() => {
                this.setContainerHeight();
            }, 300));

            // Run animation
            this.progressBarAnimation();
            
        }

    }

    /**
     * 
     */
    setContainerHeight(animate = true) {

        if (!this.SLIDER_WRAPPER) { return; }

        // Get height of active slide
        let slide_height = this.GLIDE_SLIDES[this.SLIDER._i].getBoundingClientRect().height;

        if (animate) {

            // Animate height of slider wrapper
            setTimeout(() => {
                $( ".glide__slides" ).animate({
                    maxHeight: slide_height
                }, 450, 'swing');
            }, 350);

        } else {
            
            // Set height of slider wrapper
            this.SLIDER_WRAPPER.style.maxHeight = slide_height + 'px';

        }
    }

    /**
     * Checks if slider has enough slides to slide
     */
    isSlidable() {

        if (this.SLIDER) {

            // If there's not more items than perview
            if (this.COUNT <= this.SLIDER._o.perView) {

                // Disable slider if not disabled
                if (!this.SLIDER.disabled) {
                    this.SLIDER.disable();
                }
            } else {

                // Enable slider if not enabled
                if (this.SLIDER.disabled) {
                    this.SLIDER.enable();
                }
            }
        }
    }

    /**
     * Handler for arrows
     */
    arrowHandler(CLASS = 'disabled') {

        // Check if arrows exists
        if (this.ARROW_LEFT && this.ARROW_RIGHT) {

            // Check if slider is at the beginning
            if (this.SLIDER._i === 0) { 
                addClass(this.ARROW_LEFT, CLASS);
                removeClass(this.ARROW_RIGHT, CLASS);
            } 
            
            // Check if slider is at the end
            else if (this.SLIDER._i + this.SLIDER._o.perView === this.COUNT) {
                removeClass(this.ARROW_LEFT, CLASS);
                addClass(this.ARROW_RIGHT, CLASS);
            } 
            
            // Check if slider is in the middle
            else {
                removeClass(this.ARROW_LEFT, CLASS);
                removeClass(this.ARROW_RIGHT, CLASS);
            }
        }
    }

    progressBarAnimation() {
        if (!this.PROGRESS_BAR) return;
        anime({
            targets: this.PROGRESS_BAR,
            width: ['0%', '100%'],
            easing: 'linear',
            duration: this.DURATION
        });
    }

    /**
     * Get screen width
     */
    getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}